import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms--bookings--booking-reason-toggle"
export default class extends Controller {
  static targets = ["reasonSelect", "otherReasonInput", "manualConfirmationInput"]

  connect() {
    this.showHideOtherReasonInput();
  }

  showHideOtherReasonInput() {
    const selectedOption = this.reasonSelectTarget.options[this.reasonSelectTarget.selectedIndex]
    const reasonRequired = selectedOption.dataset.reasonRequired === "true"
    this.otherReasonInputTarget.required = reasonRequired
    this.otherReasonInputTarget.parentElement.hidden = !reasonRequired
  }
}
